import getTranslations from './getTranslations';
import injectDefaults from './injectDefaults';
import setTranslations from './setTranslations';
import getStaticTranslations from './getStaticTranslations';

export const actions = {
    getTranslations,
    injectDefaults,
    setTranslations,
    getStaticTranslations,
};

export default actions;
